import React from 'react';
import { motion } from 'framer-motion';
import { Crown, X, Check } from 'lucide-react';
const withoutItems = ['Apuntes sueltos y materiales sin orden', 'Armás los resúmenes y esquemas desde cero', 'Sin guías ni plantillas para la práctica clínica', 'Material limitado y sin actualizaciones'];
const withItems = ['Sistema completo con 6 tomos + 4 bonos', 'Resúmenes, mapas y esquemas listos para usar', 'Plantillas clínicas y guías de entrevista incluidas', 'Acceso a futuras actualizaciones y nuevos recursos'];
export function Guarantee() {
  return <section className="bg-brand-darker py-16 px-4 sm:px-6 lg:px-8" data-id="element-96">
      <div className="max-w-xl mx-auto" data-id="element-97">
        {/* Comparison block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-98">
          <span className="inline-flex items-center gap-1.5 bg-brand-sky/10 text-brand-sky border border-brand-sky/30 text-xs font-bold px-3 py-1.5 rounded-full mb-5" data-id="element-99">
            <Crown className="w-3.5 h-3.5" data-id="element-100" /> EXCLUSIVO PSIRECURSOS PRO
          </span>
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3 leading-tight" data-id="element-101">
            Qué vas a obtener con{' '}
            <span className="text-brand-sky" data-id="element-102">PsiRecursos Pro</span>
          </h2>
          <p className="text-gray-400 text-[15px]" data-id="element-103">
            La diferencia entre estudiar sin rumbo y tener un sistema completo
            de estudio.
          </p>
        </motion.div>

        <div className="space-y-4 mb-14" data-id="element-104">
          {/* Sin PsiRecursos Pro */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-dark border border-white/10 rounded-2xl p-6" data-id="element-105">
            <span className="inline-flex items-center gap-2 bg-white/5 text-gray-400 text-xs font-bold px-3 py-1.5 rounded-lg mb-4" data-id="element-106">
              <X className="w-3.5 h-3.5" data-id="element-107" /> SI NO TENÉS PSIRECURSOS PRO
            </span>
            <h3 className="text-white font-bold text-lg mb-4" data-id="element-108">
              Solo tenés tus apuntes sueltos
            </h3>
            <ul className="space-y-3" data-id="element-109">
              {withoutItems.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-sm text-gray-400" data-id="element-110">
                  <X className="w-4 h-4 text-gray-500 mt-0.5 flex-shrink-0" data-id="element-111" />
                  <span data-id="element-112">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Con PsiRecursos Pro */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="relative bg-brand-dark border-2 border-brand-lilac rounded-2xl p-6 overflow-hidden" data-id="element-113">
            <div className="absolute top-0 right-0 bg-brand-lilac/10 w-32 h-32 rounded-full blur-2xl -mr-10 -mt-10 pointer-events-none" data-id="element-114" />
            <div className="flex justify-center mb-4" data-id="element-115">
              <span className="inline-flex items-center gap-1.5 bg-signature-gradient text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-116">
                <Crown className="w-3.5 h-3.5" data-id="element-117" /> RECOMENDADO
              </span>
            </div>
            <span className="inline-flex items-center gap-2 bg-brand-sky/10 text-brand-sky text-xs font-bold px-3 py-1.5 rounded-lg mb-4" data-id="element-118">
              <Check className="w-3.5 h-3.5" data-id="element-119" /> SI TENÉS PSIRECURSOS PRO
            </span>
            <h3 className="text-white font-bold text-lg mb-4" data-id="element-120">
              Tenés un sistema de estudio completo
            </h3>
            <ul className="space-y-3 relative z-10" data-id="element-121">
              {withItems.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-sm text-gray-100" data-id="element-122">
                  <Check className="w-4 h-4 text-brand-sky mt-0.5 flex-shrink-0" data-id="element-123" />
                  <span data-id="element-124">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center text-center" data-id="element-125">
          <div className="text-5xl mb-6" data-id="element-126">🛡️</div>
          <h2 className="text-2xl font-bold text-white mb-4" data-id="element-127">
            Garantía 7 días — Sin preguntas
          </h2>
          <p className="text-gray-300 mb-6 text-[15px]" data-id="element-128">
            Abrís el sistema. Lo usás. Si en 7 días no es lo que esperabas, te
            devolvemos el 100% sin formularios, sin drama.
          </p>
          <span className="inline-block bg-green-500/20 text-green-400 border border-green-500/30 text-sm font-semibold px-4 py-1.5 rounded-full" data-id="element-129">
            Tasa de devoluciones: menos del 1%.
          </span>
        </motion.div>
      </div>
    </section>;
}